import Header from "../Components/Header";
import "../Styles/product.css";
import cart_card from "./check.gif";
import eth from "../assets/images/eth.png";
import { ethers } from "ethers";
import Web3 from "web3";
import * as React from "react";
import { useEffect } from "react";
import nftabi from "./nft.json";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import * as yup from "yup";
import { useState, useRef } from "react";
import Swal from "sweetalert2";
import swal from "sweetalert";
import marketabi from "./marketabi.json";
// import Select from "react-select";
let web3 = new Web3(window.ethereum);

function PrivacyPolicy() {
  const [show, setShow] = useState(false);
  let isLogedin = localStorage.getItem("isLogedin");
  let token = localStorage.getItem("token");
  const [imageuri, setimage] = React.useState(cart_card);
  const [tokendata, settokendata] = React.useState([]);

  const Nft = new web3.eth.Contract(
    nftabi,
    process.env.REACT_APP_Nft_address
  );
  let loginConnection = localStorage.getItem("login-connection");
  let address_ = localStorage.getItem("address");
  const navigate = useNavigate();
  const success = (value) => {
    toast.success(value, { theme: "colored" });
  };
  const faild = (value) => {
    toast.error(value, { theme: "colored" });
  };
  const createhandleShow = () => setShow(true);
  const createhandleClose = () => setShow(false);
  const [_acc, setAcc] = React.useState();
  const [wallnew, setwalletnew] = React.useState();
  const [minted, setminted] = React.useState(false);
  let location = window.location.href;
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      confirmpassword: "",
      terms: false,
      notify: false,
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .email("Email must be valid email")
        .required("Email is required"),
      password: yup
        .string()
        .required("Password is required")
        .min(8, "Password is too short - should be 8 chars minimum.")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
          "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        ),
      confirmpassword: yup
        .string()
        .oneOf([yup.ref("password"), null], "Passwords must match"),
      terms: yup
        .boolean()
        .oneOf(
          [true],
          "You must accept the pricing policy terms and conditions"
        ),
      notify: yup
        .boolean()
        .oneOf(
          [true],
          "You must accept the pricing policy terms and conditions"
        ),
    }),
    onSubmit: (userinputdata) => {
      let registerdate = {
        email: userinputdata.email,
        password: userinputdata.password,
        confirm_password: userinputdata.confirmpassword,
      };

      axios
        .post(
          `${process.env.REACT_APP_Backend_url}/auth/register`,
          registerdate
        )
        .then((res) => {
          if (res.data.message === "Registration done successfully") {
            success(res.data.message);
            createhandleClose();
          } else {
            faild(res.data.message);
          }
        });
    },
  });
  var url = new URL(location);
  var id = url.searchParams.get("id");
  console.log(id);
  useEffect(() => {
    async function dataaa() {
      await loadWeb3();
      let accounts = await window.web3.eth.getAccounts();

      axios
        .get(
          `${process.env.REACT_APP_Backend_url}/auth/get-productnft?token_id=${id}`,
          {
            headers: { "x-access-token": `${token}` },
          }
        )
        .then(async (res) => {
          settokendata(res.data?.data?._userDetail[0]);
          console.log(res.data?.data?._userDetail[0]);
          if (res.data?.data?._userDetail[0]?.image) {
            setimage(res.data?.data?._userDetail[0]?.image);
            setminted(true);
          }
        });
      setAcc(accounts[0]);
      console.log(accounts[0]);

      await loadWeb3();
      let accounts_new = await window.web3.eth.getAccounts();
      axios
        .get(`${process.env.REACT_APP_Backend_url}/auth/get-all-buynft`, {
          headers: { "x-access-token": `${token}` },
        })
        .then(async (res) => {
          console.log(
            "res-",
            res.data?.data?._userDetail[0].wallet_details.address
          );
          // console.log("res-",res.data?.data?._userDetail[0]);
          if (res.data?.data?._userDetail[0]?.wallet_details) {
            console.log(
              "rrr-",
              res.data?.data._userDetail[0]?.wallet_details.address
            );
            setwalletnew(res.data?.data._userDetail[0]?.wallet_details.address);
            // setminted(true);
          } else if (res.data?.data?._userDetail[0]) {
          }
        });
    }
    dataaa();
  }, []);

  const loadWeb3 = async () => {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum);
    } else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider);
    } else {
      window.alert(
        "Non-Ethereum browser detected. You should consider trying MetaMask!"
      );
    }
  };

  const buyNft = async () => {
    // let loginConnection = localStorage.getItem("login-connection");
    let isLogedin = localStorage.getItem("isLogedin");
    if ((isLogedin === null || !isLogedin)) {
      faild("Please Login")
    } else if (!loginConnection) {
      faild("Please Connect Your Wallet")
    }


    else {
      await loadWeb3();
      const accounts = await window.web3.eth.getAccounts();
      if (address_ && accounts[0] === web3.utils.toChecksumAddress(address_)) {


        console.log(accounts[0]);

        try {
          console.log(Nft.methods);
          let name = await Nft.methods.name().call();
          console.log(name);
          let nftPrice = await Nft.methods.pricefortokenid(id).call();
          console.log("nftPrice -", nftPrice);
          let contractOwner = await Nft.methods.owner().call();
          const buy_price = web3.utils.fromWei(nftPrice.toString(), "ether");
          console.log(buy_price);
          console.log(id);

          await Nft.methods
            .BuyNFT(contractOwner, accounts[0], id)
            .send({
              from: accounts[0],
              value: Web3.utils.toWei(String(buy_price), "ether"),
              gas: 100000,
            })
            .on("transactionHash", async (res) => {
              console.log(res);
              let tokenidaddress = await Nft.methods.ownerOf(id).call();
              console.log(tokenidaddress);
              let getUriBytokenid = await Nft.methods.tokenURI(id).call();
              console.log(getUriBytokenid);

              // const response = await fetch(getUriBytokenid);

              // if (!response.ok) throw new Error(response.statusText);

              // const json = await response.json();
              // console.log(json);
              let login_data = {
                buy_price: buy_price,
                wallet_address: accounts[0],
                // image: json.image,
                // description: json.image,
                token_id: id,
                buy_transaction_id: res,
              };
              axios
                .post(
                  `${process.env.REACT_APP_Backend_url}/auth/buynft`,
                  login_data,
                  {
                    headers: { "x-access-token": `${token}` },
                  }
                )
                .then(async (res) => {
                  if (res.data.message === "Bought successfully") {
                    success(res.data.message);
                  }
                });
              // setimage(json.image);
              // console.log(json.image);
            });
        } catch (err) {
          console.log(err);
        }
      } else {
        faild("Wallet address not match")
      }
    }
    // let gettokenidByaddress = await Nft.methods.gettokenidByaddress("0x9bbc39819A0a1cE456Bd0fE59A37d2C60Ab8143F").call();
  };

  const backUrl = () => {
    navigate(-1);
  };

  return (
    <>
      <Header active="product" />
      <main>
        <div className="container ">
          <div className="row">
            <div className="col-lg-12 mt-3">
              <h2>  Privacy Policy</h2>
              <p className="terms-condition mb-2">
               
               
                <br/>

               
                These terms and conditions outline the rules and regulations for the use of Company Name's Website, located at Website.com.
                <br/>
                By accessing this website we assume you accept these terms and conditions. Do not continue to use Website Name if you do not agree to take all of the terms and conditions stated on this page.
                <br/>
                The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: “Client”, “You” and “Your” refers to you, the person log on this website and compliant to the Company's terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client's needs in respect of provision of the Company's stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.
                <br/>
                Cookies
                We employ the use of cookies. By accessing Website Name, you agreed to use cookies in agreement with the Company Name's Privacy Policy.
                <br/>
                Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.
                <br/>
                License
                Unless otherwise stated, Company Name and/or its licensors own the intellectual property rights for all material on Website Name. All intellectual property rights are reserved. You may access this from Website Name for your own personal use subjected to restrictions set in these terms and conditions.
                <br/>
                You must not:
                <br/>
                Republish material from Website Name
                Sell, rent or sub-license material from Website Name
                Reproduce, duplicate or copy material from Website Name
                Redistribute content from Website Name
                This Agreement shall begin on the date hereof.
                <br/>
                Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Company Name does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Company Name,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, Company Name shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.
                <br/>
                Company Name reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.
                <br/>
                You warrant and represent that:
                <br/>
                You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;
                The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;
                The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy
                The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.
                You hereby grant Company Name a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.
                <br/>
                Hyperlinking to our Content
                The following organizations may link to our Website without prior written approval:
                <br/>
                Government agencies;
                Search engines;
                News organizations;
                Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses; and
                System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.
                These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site.
                <br/>
                We may consider and approve other link requests from the following types of organizations:
                <br/>
                commonly-known consumer and/or business information sources;
                dot.com community sites;
                associations or other groups representing charities;
                online directory distributors;
                internet portals;
                accounting, law and consulting firms; and
                educational institutions and trade associations.
                We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of Company Name; and (d) the link is in the context of general resource information.
                <br/>
                These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site.
                <br/>
                If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to Company Name. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.
                <br/>
                Approved organizations may hyperlink to our Website as follows:
                <br/>
                By use of our corporate name; or
                By use of the uniform resource locator being linked to; or
                By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party's site.
                No use of Company Name's logo or other artwork will be allowed for linking absent a trademark license agreement.
                <br/>
                iFrames
                Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.
                <br/>
                Content Liability
                We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.
                <br/>
                Reservation of Rights
                We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and it's linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.
                <br/>
                Removal of links from our website
                If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.
                <br/>
                We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.
                <br/>
                Disclaimer
                To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:
                <br/>
                limit or exclude our or your liability for death or personal injury;
                limit or exclude our or your liability for fraud or fraudulent misrepresentation;
                limit any of our or your liabilities in any way that is not permitted under applicable law; or
                exclude any of our or your liabilities that may not be excluded under applicable law.
                The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.
                <br/>
                As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.
              </p>
            </div>

          </div>

        </div>
      </main>

    </>
  );
}
export default PrivacyPolicy;
